import {Link} from 'react-router-dom'
import styles from './Footer.module.css'

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.brand}>
        <span>ASJF</span>
        <p>Associação dos Surdos de Juiz de Fora</p>
      </div>
      <ul className={styles.links_list}>
        <li>
          <Link to="/" className={styles.link}>
            Institucional
          </Link>
        </li>
        <li>
          <Link to="/estatuto" className={styles.link}>
            Estatuto
          </Link>
        </li>
        <li>
          <Link to="/diretoria" className={styles.link}>
            Diretoria
          </Link>
        </li>
      </ul>
      <p className={styles.copy}>© 2026 ASJF. Todos os direitos reservados.</p>
    </footer>
  )
}

export default Footer
